(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 3972:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(6768);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2086);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+layout@2.0.1_gvhyduxkh7lachkwscygibi2bq/node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(7279);
// EXTERNAL MODULE: ./node_modules/.pnpm/@chakra-ui+button@2.0.1_gvhyduxkh7lachkwscygibi2bq/node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js
var chakra_ui_button_esm = __webpack_require__(9042);
// EXTERNAL MODULE: ./components/index.ts + 160 modules
var components = __webpack_require__(1080);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@4.0.0-beta.3_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/react-query/es/index.js + 25 modules
var es = __webpack_require__(6323);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.6_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(381);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/js-cookie@3.0.1/node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(6131);
;// CONCATENATED MODULE: ./utils/api.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function apiRequest(url) {
    return _apiRequest.apply(this, arguments);
}
function _apiRequest() {
    _apiRequest = _asyncToGenerator(runtime_default().mark(function _callee(url) {
        var tokenCookie, res, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    tokenCookie = js_cookie/* default.get */.Z.get("token");
                    _ctx.next = 3;
                    return fetch(url, {
                        method: "GET",
                        headers: {
                            authorization: "Bearer ".concat(tokenCookie),
                            apikey: "a9f224c8-f532-4015-9bc8-87dc33a5b057"
                        }
                    });
                case 3:
                    res = _ctx.sent;
                    _ctx.next = 6;
                    return res.json();
                case 6:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _apiRequest.apply(this, arguments);
}

;// CONCATENATED MODULE: ./hooks/useFetch.tsx


function useFetch(url, QN) {
    var queryClient = new es/* QueryClient */.Su();
    return (0,es/* useQuery */.aM)([
        QN,
        QN
    ], function() {
        return apiRequest(url);
    }, {
        initialData: function() {
            // Use a todo from the 'todos' query as the initial data for this todo query
            return queryClient.getQueryData([
                QN
            ]);
        },
        refetchOnWindowFocus: false,
        cacheTime: 100000,
        staleTime: 10000
    });
}

;// CONCATENATED MODULE: ./pages/index.tsx




function Home() {
    var ref = useFetch("https://api.axenda.io/schools", "schools"), status = ref.status, data = ref.data, error = ref.error, isFetching = ref.isFetching;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Meta */.h_, {
        title: "Main Page",
        description: "Axenda Drive main Page",
        image: "https://axed.vercel.app/favicon-512.png",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                    as: "h1",
                    textAlign: "center",
                    paddingY: "12",
                    children: "Hello in the \uD83D\uDCBD"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                        "aria-label": "Go Chooes your university",
                        as: "a",
                        href: "#unis",
                        textColor: "blue.200",
                        children: "Chooes your university \uD83D\uDED6"
                    })
                }),
                error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Reload */.L, {
                    size: "xl",
                    text: "Reload"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "unis",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Search */.ol, {
                            ph: "University Name"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                            columns: [
                                1,
                                2,
                                3,
                                4
                            ],
                            gap: 8,
                            justifyItems: "center",
                            justifyContent: "space-evenly",
                            alignContent: "space-evenly",
                            alignItems: "center",
                            // minChildWidth={["14rem", "16rem", "18rem"]}
                            m: 8,
                            children: data === null || data === void 0 ? void 0 : data.map(function(deta, id) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Card */.Zb, {
                                    img: deta.logoUrl,
                                    slug: deta.slug,
                                    name: deta.autocomplete,
                                    simple: true
                                }, deta._id != null ? deta._id : id);
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(3972); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);